// src/App.js
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom'; // Importa useNavigate
import { auth, db } from './firebaseConfig';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore'; 
import logo from './logo.png';

import Home from './Home';
import ProjectDetail from './ProjectDetail';
import Reports from './Reports';
import Timeline from './Timeline';
import Auth from './Auth';
import ChangePasswordModal from './ChangePasswordModal';
import UserManagement from './UserManagement';

function App() {
  const [user, setUser] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
  const navigate = useNavigate(); // Hook para navegação

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        setUser(currentUser);
        const userDoc = await getDoc(doc(db, "users", currentUser.uid));
        if (userDoc.exists()) {
          setUserRole(userDoc.data().role);
        } else {
          setUserRole('viewer');
        }
      } else {
        setUser(null);
        setUserRole(null);
        navigate('/'); // Redireciona para a página inicial (Home ou Login) ao deslogar
      }
      setLoading(false);
    });
    return () => unsubscribe();
  }, [navigate]); // Adiciona navigate como dependência

  const handleLogout = async () => {
    try {
      await signOut(auth);
      // O `onAuthStateChanged` acima vai pegar a mudança e redirecionar
    } catch (error) {
      console.error("Erro ao fazer logout:", error);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <p className="text-xl text-gray-700">Verificando login...</p>
      </div>
    );
  }

  if (!user) {
    return <Auth />;
  }

  return (
    // <Router> -- O BrowserRouter deve envolver tudo APENAS UMA VEZ
    <> {/* Usamos Fragment <> </> para não ter um div extra aqui */}
      <div className="flex justify-between items-center p-4 bg-white shadow-md">
        <div className="flex items-center gap-4">
          <img src={logo} alt="Logo da Empresa" className="max-h-8" />
          <p className="font-bold text-lg text-gray-800">Controle de Sistemas</p>
        </div>
        <div className="flex items-center gap-4">
          <span className="text-gray-700 text-sm">Logado como: {user.email} (<span className="uppercase font-bold">{userRole}</span>)</span>
          <button onClick={() => setIsPasswordModalOpen(true)} className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-1 px-3 rounded text-sm">
            Mudar Senha
          </button>
          <button onClick={handleLogout} className="bg-red-500 hover:bg-red-600 text-white font-bold py-1 px-3 rounded text-sm">
            Sair
          </button>
        </div>
      </div>
      {/* As rotas devem estar dentro do BrowserRouter, que está no componente acima */}
      <Routes>
        <Route path="/" element={<Home userRole={userRole} />} />
        <Route path="/projeto/:id" element={<ProjectDetail userRole={userRole} />} />
        <Route path="/relatorios" element={<Reports userRole={userRole} />} />
        <Route path="/timeline" element={<Timeline userRole={userRole} />} />
        {userRole === 'admin' && (
          <Route path="/users" element={<UserManagement userRole={userRole} />} />
        )}
      </Routes>
      {isPasswordModalOpen && <ChangePasswordModal onClose={() => setIsPasswordModalOpen(false)} />}
    </>
    // </Router>
  );
}

// O BrowserRouter deve envolver o App
const WrappedApp = () => (
  <Router>
    <App />
  </Router>
);

export default WrappedApp; // Exporta o componente App envolto em Router